import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
import Vue from 'vue'
import actionsRequests from './actionsRequests'
export default {
    messageAll: (context, botId) => {
        let url = constConf.message.url + '/message/all/' + botId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                let messages = response.response.data
                context.commit('messageAll', messages)
                return messages
            })
    },
    saveMessage: (context, payload) => {
        let method = 'post'
        let url = constConf.message.url + '/message/create'
        if (payload.model.id != null) {
            method = 'put'
            url = constConf.message.url + '/message/update/' + payload.model.id
        }
        axios.defaults.withCredentials = true
        return axios({
            method: method,
            url: url,
            data: payload.model
        })
            .then((response) => {
                let functionName = { put: 'setMessage', post: 'addMessage' }
                context.commit(functionName[method], response.data)
                return response.data // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
                return null
            })
    },
    removeMessage: (context, messageId) => {
        return axios({
            method: 'delete',
            url: constConf.message.url + '/message/delete/' + messageId
        })
            .then((response) => {
                if (response.data.type === 'MessageDelete') {
                    context.commit('removeMessage', response.data.response.data)
                }
                return response.data
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    createTempMessage: (context, payload) => {
        return context.commit('createTempMessage', payload)
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    loadMessageLists: (context, botId) => {
        let url = constConf.message.url + '/message-list/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.type === 'AllResult') {
                    context.commit('loadMessageLists', response.response.data)
                } else {
                    context.commit('loadMessageLists', [])
                }
            })
    },
    saveMessageList: (context, data) => {
        let method = 'post'
        let url = constConf.message.url + '/message-list/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.message.url + '/message-list/update/' + data.id
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                let functionName = { put: 'setMessageList', post: 'addMessageList' }
                context.commit(functionName[method], response.response.data)
                return response
            })
    },
    deleteMessageList: (context, id) => {
        let url = constConf.message.url + '/message-list/delete/' + id
        return context.dispatch('axios/query', { url: url, method: 'delete' }, { root: true })
            .then(response => {
                if (response.type === 'DeleteResult') {
                    context.commit('deleteMessageList', response.response.data)
                }
                return response
            })
    },
    loadMessageSortedInList: (context, payload) => { // загрузка и распределение сообщений по спискам
        let unsortedMessages = context.getters.messages.slice()
        let messageSortedInList = {}
        payload.messageLists.forEach((item) => {
            if (!messageSortedInList.hasOwnProperty(item.id)) {
                Vue.set(messageSortedInList, item.id, [])
            }
            if (item.messages.length !== 0) {
                item.messages.forEach((messageId) => {
                    let message = context.getters.getMessageById(+messageId)
                    if (message) { messageSortedInList[item.id].push(message) }
                    let index = unsortedMessages.findIndex(message => message.id === +messageId)
                    unsortedMessages.splice(index, 1)
                })
            }
        })
        unsortedMessages.forEach((message) => {
            messageSortedInList[context.getters.unsortedMessagesListId].push(message)
        })
        context.commit('loadMessageSortedInList', messageSortedInList)
        context.commit('allLoadedChangeValue', false)
    },
    sortMessagesInMessageList: (context, payload) => {
        let messages = []
        let unique = []
        for (let i = (context.getters.messageSortedInList[payload.messageListId].length - 1); i >= 0; i--) {
            if (unique.indexOf(context.getters.messageSortedInList[payload.messageListId][i].id) >= 0) { // если в списке уже есть сообщение с похожим id, значит нужно удалить его
                context.commit('deleteMessageInMessageList', { messageListId: payload.messageListId, index: i })
            } else {
                unique.push(context.getters.messageSortedInList[payload.messageListId][i].id)
                messages.push(context.getters.messageSortedInList[payload.messageListId][i].id)
            }
        }
        messages.reverse()
        return messages
    },
    addMessageToMessageList: (context, payload) => {
        context.commit('addMessageToMessageList', payload)
    },
    updateMessageInMessageList: (context, payload) => {
        context.commit('updateMessageInMessageList', payload)
    },
    uploadImage: (context, { botId, formData }) => {
        return axios.post(constConf.message.url + '/medialibrary/upload/' + botId, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error.response)
            })
    },
    ...actionsRequests
}
